module.exports = __webpack_public_path__ + "assets\\img\\icons\\apple-touch-icon.png?963ca284ae4e8ba3f489";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/apple-touch-icon.png
// module id = 150
// module chunks = 0